import * as Sentry from '@sentry/nextjs';

export const enum SentryGroup {
  policyTransaction = 'policyTransaction',
  nextWay = 'nextWay',
  predictiRest = 'predictiRest',
  tiaParty = 'tiaParty',
  tiaPolicy = 'tiaPolicy',
  tiaClaim = 'tiaClaim',
  tiaCommon = 'tiaCommon',
  tiaIntegration = 'tiaIntegration',
  tiaCase = 'tiaCase',
  sjf = 'sjf',
  userManagement = 'userManagement',
  tiaAccount = 'tiaAccount',
  auth = 'authorization',
  document = 'document',
  buyInsurance = 'buy-insurance',
  common = 'common',
  sentry = 'sentry',
  acceptOffer = 'acceptOffer',
  basket = 'basket',
  mobile = 'mobile',
  risk = 'risk',
  data = 'data',
  claim = 'claim',
  faq = 'faq',
  profile = 'profile',
  sanity = 'sanity',
  consent = 'consent',
  validation = 'validation',
  cpr = 'cpr-integration',
  onboarding = 'onboarding',
  inbox = 'inbox',
}

export interface SentryMessageOptions {
  group: SentryGroup;
  message?: string | Error;
  tag?: string;
  level?: Sentry.SeverityLevel;
  printToConsole?: boolean;
  consoleMessage?: string | string[];
  fingerprint?: string[];
}

export const addMessageWithGroup = ({
  message,
  group,
  tag,
  level = 'error',
  printToConsole = false,
  consoleMessage,
  fingerprint,
}: SentryMessageOptions) => {
  Sentry.configureScope((scope) => {
    if (tag) {
      scope.setTag('tag', tag);
    }
    scope.setTransactionName(group);
    scope.setFingerprint(fingerprint || [group]);
    scope.setLevel(level);

    if (message instanceof Error) {
      Sentry.captureException(message);
    } else if (message) {
      Sentry.captureMessage(message, level);
    }
  });
  if (printToConsole) {
    printMessageByLevel(consoleMessage, level, { group, tag });
  }
};

const printMessageByLevel = (
  message: string | string[],
  level: Sentry.SeverityLevel,
  context?: { group?: string; tag?: string },
) => {
  const timestamp = new Date().toISOString();
  const location = [context?.group, context?.tag].filter(Boolean).join(':');
  const prefix = `[${timestamp}]${location ? ` [${location}]` : ''} [${level.toUpperCase()}]`;

  const lines = Array.isArray(message) ? message : [message];
  const formatted = lines.map((line) => `${prefix} ${line}`).join('\n');

  if (level === 'error' || level === 'fatal') {
    console.error(formatted);
  } else if (level === 'warning') {
    console.warn(formatted);
  } else {
    console.log(formatted);
  }
};
